import { DateInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import FilterLayout from "./FilterLayout";
import { DateFilter } from "../../../contexts/OrderListFilterContext";

interface Props {
  filterName: string;
  onDateChange: (values: DateFilter) => void;
  dateFilter?: DateFilter;
}

const parseMantineDateValue = (value: string | Date | null | undefined) => {
  if (!value) {
    return undefined;
  }

  return new Date(value);
};

const DateRange = ({ filterName, onDateChange, dateFilter = {} }: Props) => {
  return (
    <FilterLayout filterName={filterName}>
      <DateInput
        label="From"
        placeholder="Start date"
        clearable
        size="xs"
        onChange={value =>
          onDateChange({
            ...dateFilter,
            start: parseMantineDateValue(value),
          })
        }
        w="100%"
        leftSection={<IconCalendar />}
        value={dateFilter?.start}
      />
      <DateInput
        label="To"
        placeholder="End date"
        clearable
        size="xs"
        onChange={value =>
          onDateChange({
            ...dateFilter,
            end: parseMantineDateValue(value),
          })
        }
        w="100%"
        leftSection={<IconCalendar />}
        value={dateFilter?.end}
      />
    </FilterLayout>
  );
};

export default DateRange;
